import { render, staticRenderFns } from "./AccountReferral.vue?vue&type=template&id=14a40fa2&"
import script from "./AccountReferral.vue?vue&type=script&lang=js&"
export * from "./AccountReferral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14a40fa2')) {
      api.createRecord('14a40fa2', component.options)
    } else {
      api.reload('14a40fa2', component.options)
    }
    module.hot.accept("./AccountReferral.vue?vue&type=template&id=14a40fa2&", function () {
      api.rerender('14a40fa2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/components/AccountReferral.vue"
export default component.exports